import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { LicenseStateService } from 'src/app/services/license-state.service';
import { enumLicenseStatus } from 'src/app/shared/pipes/license-status.pipe';

@Injectable()
export class LicenseInterceptor implements HttpInterceptor {
  constructor(
    private readonly licenseState: LicenseStateService,
    private readonly router: Router,
    private readonly message: MessageService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(event => {
        if (!(event instanceof HttpResponse)) return;

        const licenseHeader = event.headers.get('x-nx-license');
        if (!licenseHeader) return;

        if (this.router.url.includes('/license-inactive')) return;

        if (licenseHeader === enumLicenseStatus.ACTIVE) {
          this.licenseState.setHeaderStatus(licenseHeader);
          return;
        }

        this.licenseState.loadLicense();

        setTimeout(() => {
          this.router.navigateByUrl('/license-inactive');
        }, 1500);

        if (licenseHeader !== this.licenseState.currentHeaderStatus) {
          this.message.clear();
          this.licenseState.setHeaderStatus(licenseHeader);

          switch (licenseHeader) {
            case enumLicenseStatus.INACTIVE:
              this.message.add({
                severity: 'warn',
                summary: 'Licenza inattiva',
                detail: 'La licenza non è attiva. Aspettare la data di attivazione.',
                sticky: true,
              });
              break;
            case enumLicenseStatus.EXPIRED:
              this.message.add({
                severity: 'warn',
                summary: 'Licenza scaduta',
                detail: 'La licenza è scaduta. Rinnovare la licenza.',
                sticky: true,
              });
              break;
            case enumLicenseStatus.NOT_FOUND:
              this.message.add({
                severity: 'error',
                summary: 'Licenza non trovata',
                detail: 'La licenza non è stata trovata.',
                sticky: true,
              });
              break;
            case enumLicenseStatus.ERROR:
              this.message.add({
                severity: 'error',
                summary: 'Errore',
                detail: 'Errore nel recupero della licenza.',
                sticky: true,
              });
              break;
          }
        }
      })
    );
  }
}
